import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App.tsx'
import { createClient, TRPCProvider } from './trpc.ts'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Puzzle state is authoritative on the server and changes only in
      // response to our own mutations, so background refetching is noise.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const trpcClient = createClient()

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <App />
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
)
